module.exports = __webpack_public_path__ + "Flag-404.eaf171e1372159cba8b6b7d3e02d0ca1.svg";